import React, { useEffect, useState, useRef } from 'react';
import { GetCoursesBaseUrl } from "../constants/config";
import Overlay from './Overlay';

function CourseViewer(props) {
  const [isLoading, setIsLoading] = useState(false);

  const [iframeSrc, setIframeSrc] = useState(null);
  let viewerClass = "flex-1";
  if (props.hasChapters) {
    viewerClass += " position-relative";
  }

  useEffect(() => {
    if (props.coursePageLink) {
      setIsLoading(true);
      const coursesBaseUrl = GetCoursesBaseUrl();
      const pageLink = `${coursesBaseUrl}/${props.courseRootPath}/${props.coursePageLink}`;
      setIframeSrc(pageLink);
    }

  }, [props]);

  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;

    const handleLoad = () => {
      setIsLoading(false);
    };

    if (iframe) {
      iframe.addEventListener('load', handleLoad);
    }
    return () => {
      if (iframe) {
        iframe.removeEventListener('load', handleLoad);
      }
    };
  }, []);

  return (
    <div className={viewerClass}>
      {!props.hasChapters && isLoading && <Overlay LoadingText="Loading..." />}
      {/* <div className="flex justify-between items-center mb-4" style={{ display: "none" }}>
        <div className="flex space-x-3 items-center" style={{ width: "80%" }}>
          <button className="bg-gray-300 px-2 py-1">Hide Menu</button>
          <button className="bg-gray-300 px-2 py-1">Previous</button>
          <button className="bg-gray-300 px-2 py-1">Next</button>
          <button className="bg-gray-300 px-2 py-1">Close Item</button>
          <div className="mb-2" style={{ width: "40%", display: "none" }}>
            <span className="text-gray-700" style={{ fontSize: "x-small", fontStyle: "italic", fontWeight: 500 }}>Progress...</span>
            <div className="w-1/2 bg-gray-300 rounded-full h-4">
              <div className="bg-blue-600 h-4 rounded-full" style={{ width: "70%" }}></div>
            </div>
          </div>
        </div>
        <button className="bg-gray-300 px-2 py-1">Return to LMS</button>
      </div> */}
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        title="Course"
        allowFullScreen
        style={{ position: 'absolute', height: '100%', width: '100%', border: 'none' }}
      />
    </div>
  );
}

export default CourseViewer;
